import {ClientReportInfo, ClientReportSortBy, SortOrder} from "./domain";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../pagination";

export type ClientReportListAction =
    | { type: 'SET_SELECTED'; selected: ClientReportInfo | null }
    | { type: 'SET_SORT_BY'; sortBy: ClientReportSortBy }
    | { type: 'SET_REPORT_TYPE_FILTER'; reportTypeFilter: string }
    | { type: 'SET_REPORT_STATUS_FILTER'; reportStatusFilter: string }
    | { type: 'TOGGLE_GROUP_BY_SF_OPERATION_CASE'}
    | { type: 'SHOW_NEW_MODAL' }
    | { type: 'HIDE_NEW_MODAL' }
    | { type: 'SHOW_VIEW_MODAL'; }
    | { type: 'HIDE_VIEW_MODAL'; }
    | RelayPaginationActionPayload;


export interface ClientReportListState {
    showViewModal: boolean;
    showNewModal: boolean;
    selected: ClientReportInfo | null;
    pagination: RelayPaginationState;
    sortBy: ClientReportSortBy;
    reportTypeFilter: string;
    reportStatusFilter: string;
    applyGroupBySfOperationCase: boolean;
}


export function initState(shouldShowNewModal: boolean): ClientReportListState {
    return {
        showViewModal: false,
        reportStatusFilter: "",
        reportTypeFilter: "",
        showNewModal: shouldShowNewModal,
        selected: null,
        pagination: new RelayPaginationState('0', 8),
        sortBy: {
            column: "submittedAt",
            order: SortOrder.ASC,
        },
        applyGroupBySfOperationCase: true,
    };
}

export function clientReportReducer(
    state: ClientReportListState,
    action: ClientReportListAction
): ClientReportListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            }
        case 'SHOW_VIEW_MODAL':
            return {
                ...state,
                showViewModal: true
            }
        case 'HIDE_VIEW_MODAL':
            return {
                ...state,
                showViewModal: false
            }
        case 'SHOW_NEW_MODAL':
            return {
                ...state,
                showNewModal: true
            }
        case 'HIDE_NEW_MODAL':
            return {
                ...state,
                showNewModal: false
            }
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy,
                ...emptySortState,
            };
        case 'SET_REPORT_TYPE_FILTER':
            return {
                ...state,
                reportTypeFilter: action.reportTypeFilter,
                ...emptySortState,
            };
        case 'SET_REPORT_STATUS_FILTER':
            return {
                ...state,
                reportStatusFilter: action.reportStatusFilter,
                ...emptySortState,
            };
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'TOGGLE_GROUP_BY_SF_OPERATION_CASE':
            return {
                ...state,
                applyGroupBySfOperationCase: !state.applyGroupBySfOperationCase,
                ...emptySortState,
            };
        default:
            return state;
    }
}

const emptySortState = {
    pagination: new RelayPaginationState('0', 8),
    selected: null,
}